import i18n from '../../i18n/i18n';

export function formatDate(dateString?: string | null) {
	if (!dateString) return '-';
	const d = new Date(dateString);
	return d.toLocaleDateString('en-GB');
}

function formatTimeAgo(value: number, unitKey: string) {
	const language = i18n.resolvedLanguage ?? i18n.language;
	const getPosition = (key: string) => {
		const value = i18n.getResource(language, 'translation', key);
		return typeof value === 'string' ? value.trim() : '';
	};

	return [
		getPosition('T_SITE_PROFILE_STATISTICS_AGO_PREFIX'),
		value,
		i18n.t(unitKey),
		getPosition('T_SITE_PROFILE_STATISTICS_AGO_SUFFIX'),
	]
		.filter(part => part !== '')
		.join(' ');
}

export function timeAgo(dateString?: string | null) {
	if (!dateString) return '-';
	const d = new Date(dateString).getTime();
	const now = Date.now();
	const diffSec = Math.floor((now - d) / 1000);

	if (diffSec < 60) return formatTimeAgo(diffSec, 'T_SITE_SECONDS');
	if (diffSec < 3600) return formatTimeAgo(Math.floor(diffSec / 60), 'T_SITE_MINUTES');
	if (diffSec < 86400) return formatTimeAgo(Math.floor(diffSec / 3600), 'T_SITE_HOURS');
	return formatTimeAgo(Math.floor(diffSec / 86400), 'T_SITE_DAYS');
}

export function getTimeLeft(isoString: string) {
	const future = new Date(isoString).getTime();
	const now = Date.now();
	const diff = future - now;

	if (diff <= 0) return '00:00:00';

	const hours = Math.floor(diff / (1000 * 60 * 60));
	const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
	const seconds = Math.floor((diff % (1000 * 60)) / 1000);

	const pad = (n: number) => String(n).padStart(2, '0');
	return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export function getDaysUntilExpiry(dateString?: string | null): number | null {
	if (!dateString) return null;
	const expiryDate = new Date(dateString).getTime();
	if (isNaN(expiryDate)) return null;
	const now = Date.now();
	const diffMs = expiryDate - now;
	return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
}

export function formatTimeParts(ms: number) {
	const totalSeconds = Math.floor(ms / 1000);

	const days = Math.floor(totalSeconds / 86400);
	const hours = Math.floor((totalSeconds % 86400) / 3600);
	const minutes = Math.floor((totalSeconds % 3600) / 60);
	const seconds = totalSeconds % 60;

	return {
		d: days.toString(),
		h: hours.toString().padStart(2, '0'),
		m: minutes.toString().padStart(2, '0'),
		s: seconds.toString().padStart(2, '0'),
	};
}
